<template>
  <div>
    <main class="l-content">
      <MainCarousel v-if="!isMenu" :carousel="top_banner" />
      <Description
        v-if="!isMenu"
        :col1="restaurantData.description1"
        :col2="restaurantData.description2"
      />

      <ImagesCarousel v-if="!isMenu" :carousel="gallery" is-gallery />
      <!--      <ImagesCarousel :carousel="menu_banner" :caption="$t('Ціни уточнюйте в адміністратора')" />-->
      <MenuCarousel />
    </main>
  </div>
</template>

<script>
import MainCarousel from "../components/MainCarousel";
import ImagesCarousel from "../components/ImagesCarousel";
import { http } from "../axios";
import Description from "../components/Description";
import MenuCarousel from "../components/MenuCarousel";

export default {
  name: "Restaurant",
  components: { MenuCarousel, Description, ImagesCarousel, MainCarousel },
  data() {
    return {
      restaurantData: {},
      top_banner: {},
      gallery: {},
      menu_banner: {},
      pending: false,
    };
  },
  computed: {
    getRestaurantSlug() {
      return this.$route.params.slug;
    },
    isMenu() {
      return this.$route.name === "menu" || this.$route.name === "menu-with-category";
    },
  },
  methods: {
    load() {
      this.pending = true;

      http
        .get(`api/restaurant/restaurant?slug=${this.getRestaurantSlug}`)
        .then(({ data }) => {
          this.restaurantData = data.data;
          this.top_banner = this.restaurantData.top_banner;
          this.gallery = this.restaurantData.gallery;
          this.menu_banner = this.restaurantData.menu_banner;

          if (this.restaurantData.facebook) {
            this.$store.commit("footerSocials/setProperty", [
              "facebook",
              this.restaurantData.facebook,
            ]);
          }
          if (this.restaurantData.instagram) {
            this.$store.commit("footerSocials/setProperty", [
              "instagram",
              this.restaurantData.instagram,
            ]);
          }
          if (this.restaurantData.youtube) {
            this.$store.commit("footerSocials/setProperty", [
              "youtube",
              this.restaurantData.youtube,
            ]);
          }
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
  created() {
    this.load();
  },
  watch: {
    "$route.params.id"() {
      this.load();
    },
  },
};
</script>

<style></style>
